import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { Textarea } from 'primeng/textarea';
import {
  FormControlComponent,
  PrimengButtonDirective,
  PrimengTextareaDirective,
} from '@web/shared/ui';
import { Nillable, valueOrDefault } from '@web/utils';
import {
  AdminValidationSettingsFormData,
  AdminValidationSettingsFormGroup,
} from '../../models/admin-validation-settings-form-data';

@Component({
  selector: 'app-admin-validation-settings-form',
  imports: [
    Button,
    CommonModule,
    FormControlComponent,
    PrimengButtonDirective,
    PrimengTextareaDirective,
    ReactiveFormsModule,
    Textarea,
  ],
  templateUrl: './admin-validation-settings-form.component.html',
  styleUrl: './admin-validation-settings-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminValidationSettingsFormComponent implements OnInit {
  private readonly builder = inject(FormBuilder);

  public readonly data = input.required<AdminValidationSettingsFormData>();
  public readonly submitClickEvent = output<AdminValidationSettingsFormData>();

  protected readonly form = this.buildForm();

  public ngOnInit(): void {
    this.fillByData();
  }

  public handleSubmitClick(): void {
    this.submitClickEvent.emit(this.toData());
  }

  private toData(): AdminValidationSettingsFormData {
    const data = this.form.getRawValue();
    const nipBlackList = valueOrDefault(data.nipBlackList, '')
      .split(/\r?\n/)
      .map((entry) => entry.trim())
      .filter((entry) => entry.length > 0);

    return new AdminValidationSettingsFormData({
      nipBlackList,
    });
  }

  private buildForm(): AdminValidationSettingsFormGroup {
    return this.builder.group({
      nipBlackList: this.builder.control<Nillable<string>>(null),
    });
  }

  private fillByData(): void {
    this.form.patchValue(
      {
        nipBlackList: this.data().nipBlackList.join('\n'),
      },
      { emitEvent: false },
    );
  }
}
